function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#3D84FF",
  fillRule: "nonzero",
  d: "M28.831.405A1.32 1.32 0 0 0 27.893 0c-.336 0-.67.135-.939.405L13.209 14.23 8.113 9.105c-.536-.54-1.408-.54-1.877 0L.402 14.837a1.31 1.31 0 0 0 0 1.889l11.801 11.87c.268.27.604.404.939.404.335 0 .67-.135.938-.405L34.598 8.093a1.31 1.31 0 0 0 0-1.888L28.83.405zM13.21 25.763L3.285 15.78l3.89-3.911 5.095 5.125c.268.27.604.405.939.405.335 0 .67-.135.939-.405L27.893 3.17l3.889 3.911-18.573 18.682z",
  transform: "translate(2 2)"
});

const SvgIcSuccess = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-success.bd00bf67.svg";
export { ForwardRef as ReactComponent };